<div class="padding-l60 padding-b10">
  <button (click)="createRzpayOrder()" style="color:white" class="primary" mat-flat-button>PAY NOW</button>
<!-- 
  <div fxLayout="row" fxFlex=50>
    <div (click)="createRzpayOrder()" class="padding-10 faliure-bg pointer mat-elevation-z1" matRipple fxFlex.gt-md="25" fxFlex.lt-md
      fxLayoutAlign="center center">
      <span class="icon_color">PAYNOW</span>
    </div>
  </div> -->
</div>